export default __webpack_public_path__ + "locales/zh-CN/VersionHistory.json?hash=2b6fbb3be4873abf2be723e24a261420";